var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = { key: 0 };
import { apiErrorsHandle, loadScript, } from '@common/utils/Helpers/Helpers';
import BaseMobileMenu from '../../../components/BaseMobileMenu.vue';
import { primaryStyles } from '@common/utils/Colors/Colors';
import LandingOrderForm from '@student/pages/Course/CourseAbout/components/LandingOrderForm.vue';
import { AuthModalStore, CourseStore } from '@student/modules/store';
import Auth from '@common/modules/auth';
import OrderSuccessfulInstallment from '@student/components/Landing/Course/OrderSuccessfulInstallment.vue';
import { computed, defineAsyncComponent, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useMeta } from '@common/hooks/useMeta';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CourseAbout',
    setup: function (__props) {
        var _this = this;
        var router = useRouter();
        var route = useRoute();
        var block_header = defineAsyncComponent(function () { return import('@student/components/Landing/Course/Blocks/CourseHeader/CourseHeader.vue'); });
        var block_who_suits = defineAsyncComponent(function () { return import('@student/components/Landing/Course/Blocks/WhoSuitsCourse.vue'); });
        var block_what_will_you_learn = defineAsyncComponent(function () { return import('@student/components/Landing/Course/Blocks/WhatWillYouLearn.vue'); });
        var block_how_training_going = defineAsyncComponent(function () { return import('@student/components/Landing/Course/Blocks/HowTrainingGoing.vue'); });
        var block_training_program = defineAsyncComponent(function () { return import('@student/components/Landing/Course/Blocks/CourseProgram.vue'); });
        var block_teachers = defineAsyncComponent(function () { return import('@student/components/Landing/Course/Blocks/Teachers.vue'); });
        var block_reviews = defineAsyncComponent(function () { return import('@student/components/Landing/Course/Blocks/Reviews.vue'); });
        var block_order = defineAsyncComponent(function () { return import('@student/components/Landing/Course/Blocks/Order.vue'); });
        var block_order_plan = defineAsyncComponent(function () { return import('@student/components/Landing/Course/Blocks/OrderPlan.vue'); });
        var block_faq = defineAsyncComponent(function () { return import('@student/components/Landing/Course/Blocks/Faq.vue'); });
        var LandingFooter = defineAsyncComponent(function () { return import('@student/components/Landing/Course/Blocks/LandingFooter.vue'); });
        var blocks = {
            block_header: block_header,
            block_who_suits: block_who_suits,
            block_what_will_you_learn: block_what_will_you_learn,
            block_how_training_going: block_how_training_going,
            block_training_program: block_training_program,
            block_teachers: block_teachers,
            block_reviews: block_reviews,
            block_order: block_order,
            block_order_plan: block_order_plan,
            block_faq: block_faq,
        };
        var loading = ref(true);
        // блин да, костыль
        onMounted(function () {
            setTimeout(function () {
                loading.value = false;
            }, 1500);
        });
        var course = computed(function () { return CourseStore.course; });
        var courseLoading = computed(function () { return CourseStore.courseLoading; });
        var landing = computed(function () { return CourseStore.landing; });
        var landingExternalUrl = computed(function () { return CourseStore.landingExternalUrl; });
        var useLandingExternalUrl = computed(function () { return CourseStore.useLandingExternalUrl; });
        var features = computed(function () {
            if (course.value.includes) {
                return JSON.parse(course.value.includes);
            }
            return [];
        });
        var styles = computed(function () {
            var primaryColor = landing.value && landing.value.primaryColor ? landing.value.primaryColor : '#17b198';
            return primaryStyles(primaryColor);
        });
        var setTitle = useMeta().setTitle;
        watch(course, function (val) {
            if (val && val.allowed === true) {
                // Редирект на страницу обучения
                router.push({
                    name: 'courseLearn',
                    params: { courseId: course.value.id, },
                }).catch(function () { });
            }
        });
        onMounted(function () {
            var courseId = Number(route.params.courseId);
            var slug = route.params.slug;
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
            CourseStore.getCourse(courseId || slug, courseId ? 'id' : 'slug')
                .then(function () {
                // Редирект на страницу обучения
                if (course.value.allowed) {
                    router.push({
                        name: 'courseLearn',
                        params: { courseId: course.value.id, },
                    }).catch(function () { });
                    return;
                }
                // Редирект на внешний лендинг если функция включена
                if (useLandingExternalUrl.value) {
                    location.href = landingExternalUrl.value;
                    return;
                }
                // // Редирект на страницу курсов если лендос не был опубликован ни разу
                if (!landing.value.id) {
                    router.push({ name: 'schoolCourses', }).catch(function () { });
                    if (Auth.isGuest()) {
                        AuthModalStore.show('login');
                    }
                    return;
                }
                setTitle(course.value.name);
                initAnalitics();
                var pageParams = (new URL(document.location)).searchParams;
                if (pageParams.has('payment-success')) {
                    analyticsTrackSuccessPayment();
                }
            })
                .catch(function (err) {
                apiErrorsHandle(err, {}, { notifyDuration: 5000 });
                router.push({ name: 'schoolCourses', }).catch(function () { });
            });
        });
        var initAnalitics = function () { return __awaiter(_this, void 0, void 0, function () {
            /**
             *
             */
            function gtag() { dataLayer.push(arguments); }
            var vkPixelCode_1, _tmr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (landing.value.yandexMetrikaCode) {
                            try {
                                // Init Yandex Metrika
                                (function (m, e, t, r, i, k, a) {
                                    m[i] = m[i] || function () {
                                        (m[i].a = m[i].a || []).push(arguments);
                                    };
                                    m[i].l = 1 * Date.now();
                                    k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a);
                                })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');
                                window.ym(landing.value.yandexMetrikaCode, 'init', {
                                    clickmap: true,
                                    webvisor: true,
                                    accurateTrackBounce: true,
                                });
                            }
                            catch (e) {
                                console.warn('Ошибка инициализации яндекс.метрики');
                                console.error(e);
                            }
                        }
                        if (!landing.value.googleAnalyticsCode) return [3 /*break*/, 3];
                        if (!landing.value.googleAnalyticsCode.startsWith('UA-')) return [3 /*break*/, 1];
                        try {
                            // Init Google Analytics
                            (function (i, s, o, g, r, a, m) {
                                i['GoogleAnalyticsObject'] = r;
                                i[r] = i[r] || function () {
                                    (i[r].q = i[r].q || []).push(arguments);
                                }, i[r].l = 1 * Date.now();
                                a = s.createElement(o),
                                    m = s.getElementsByTagName(o)[0];
                                a.async = 1;
                                a.src = g;
                                m.parentNode.insertBefore(a, m);
                            })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
                            window.ga('create', landing.value.googleAnalyticsCode, 'auto');
                            window.ga('send', 'pageview');
                        }
                        catch (e) {
                            console.warn('Ошибка инициализации google analytics');
                            console.error(e);
                        }
                        return [3 /*break*/, 3];
                    case 1:
                        if (!landing.value.googleAnalyticsCode.startsWith('G-')) return [3 /*break*/, 3];
                        return [4 /*yield*/, loadScript("https://www.googletagmanager.com/gtag/js?id=".concat(landing.value.googleAnalyticsCode))];
                    case 2:
                        _a.sent();
                        window.dataLayer = window.dataLayer || [];
                        gtag('js', new Date());
                        gtag('config', 'TAG_ID');
                        _a.label = 3;
                    case 3:
                        if (landing.value.facebookPixel) {
                            try {
                                !function (f, b, e, v, n, t, s) {
                                    if (f.fbq)
                                        return;
                                    n = f.fbq = function () {
                                        n.callMethod ?
                                            n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                                    };
                                    if (!f._fbq)
                                        f._fbq = n;
                                    n.push = n;
                                    n.loaded = !0;
                                    n.version = '2.0';
                                    n.queue = [];
                                    t = b.createElement(e);
                                    t.async = !0;
                                    t.src = v;
                                    s = b.getElementsByTagName(e)[0];
                                    s.parentNode.insertBefore(t, s);
                                }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
                                window.fbq('init', landing.value.facebookPixel);
                                window.fbq('track', 'PageView');
                            }
                            catch (_b) { }
                        }
                        if (landing.value.vkPixel) {
                            vkPixelCode_1 = landing.value.vkPixel;
                            // Если пиксель из нового рк, то юзаем новый код
                            if (/^\d+$/.test(vkPixelCode_1)) {
                                try {
                                    _tmr = window._tmr || (window._tmr = []);
                                    _tmr.push({
                                        id: vkPixelCode_1, type: 'pageView', start: Date.now()
                                    });
                                    (function (d, w, id) {
                                        if (d.getElementById(id))
                                            return;
                                        var ts = d.createElement('script');
                                        ts.type = 'text/javascript';
                                        ts.async = true;
                                        ts.id = id;
                                        ts.src = 'https://top-fwz1.mail.ru/js/code.js';
                                        var f = function () { var s = d.querySelectorAll('script')[0]; s.parentNode.insertBefore(ts, s); };
                                        if (w.opera == '[object Opera]') {
                                            d.addEventListener('DOMContentLoaded', f, false);
                                        }
                                        else {
                                            f();
                                        }
                                    })(document, window, 'tmr-code');
                                }
                                catch (err) {
                                    console.error('При включении VKPixel произошла ошибка:', err);
                                }
                            }
                            else {
                                try {
                                    !function () { var t = document.createElement('script'); t.type = 'text/javascript', t.async = !0, t.src = 'https://vk.com/js/api/openapi.js?169', t.addEventListener('load', function () { VK.Retargeting.Init(vkPixelCode_1), VK.Retargeting.Hit(); }), document.head.appendChild(t); }();
                                }
                                catch (err) {
                                    console.error('При включении VKPixel произошла ошибка:', err);
                                }
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var analyticsTrackSuccessPayment = function () {
            var price = course.value.price;
            if (landing.value.facebookPixel) {
                window.fbq('track', 'Purchase', {
                    currency: 'RUB', value: price
                });
            }
            if (landing.value.vkPixel) {
                window.VK.Goal('purchase', { value: price });
            }
        };
        return function (_ctx, _cache) {
            var _directive_loading = _resolveDirective("loading");
            return _withDirectives((_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle(styles.value),
                class: "page-content bg-white"
            }, [
                _createVNode(BaseMobileMenu),
                (landing.value && landing.value.blocks)
                    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(landing.value.blocks, function (block) {
                            return (_openBlock(), _createBlock(_resolveDynamicComponent(blocks[block.type]), {
                                key: block.id,
                                "landing-block": block
                            }, null, 8, ["landing-block"]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(LandingOrderForm, {
                    style: _normalizeStyle(styles.value)
                }, null, 8, ["style"]),
                _createVNode(OrderSuccessfulInstallment),
                _createVNode(_unref(LandingFooter), {
                    "social-networks": landing.value.socialNetworksUrls
                }, null, 8, ["social-networks"])
            ], 4)), [
                [_directive_loading, loading.value]
            ]);
        };
    }
});
